import { Banner } from "../interfaces/Banner";

export const initalBanner: Banner = {
  title: '',
  text: '',
  linkText: '',
  linkAddress: '',
  expiryHours: 0
}
